import React from 'react';
import { Link } from 'react-router-dom';

const Page404 = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for doesn't exist or another error occurred.</p>
      <p><Link to="/">Go back to the homepage</Link></p>
    </div>
  );
};

export default Page404;
